'use strict'

const shadow = { // eslint-disable-line
  name: 'primaryShadow',
  boxShadow: 'gray12, 0 0px 50px 50px'
}

export const SHADOW = {}
